import React, { Component } from 'react';
//import {connect} from 'react-redux';

import './../../../scss/App.scss';
import FormContainer from '../form/FormContainer';

//import { trackingWrapper } from '../../utils/analytics';

class Step2 extends Component {

	constructor(props){
		super(props);

		this.state = {
			"categoryData": this.props.categoryData
		}

		console.log("this.props.categoryData", this.props.categoryData);
	}

	componentDidMount(){
		//this.animateIn();

		//window.sounds.introBg.play();

		/*
		let _this = this;

		setTimeout(() => {
			_this.props.handleIntroComplete();
		}, 3000);
		*/

	}

	animateIn(){
		/*
		window.TweenMax.set(this.refs.logo, {transform:"translateX(-10%)", opacity:0});
		window.TweenMax.to(this.refs.logo, 2.2, {ease:"expo.out", transform:"translateX(-50%)", opacity:1});

		window.TweenMax.set(this.refs.tagline, {transform:"translateX(-90%)", opacity:0});
		window.TweenMax.to(this.refs.tagline, 2.2, {ease:"expo.out", transform:"translateX(-50%)", opacity:1});

		window.TweenMax.set(this.refs.crosswordBg, {opacity:0});
		window.TweenMax.to(this.refs.crosswordBg, 2, {ease:"linear", opacity:1});
		window.TweenMax.to(this.refs.crosswordBg, 20, {top:"-16vw"});

		let _this = this;
		setTimeout(() => {
			_this.aniamteOut();
			_this.props.handleIntroInComplete()
		}, 4000);
		*/
	}

	aniamteOut(){
		/*
		let _this = this;

		window.TweenMax.to(this.refs.crosswordBg, .2, {opacity:0});
		window.TweenMax.to(this.refs.host, .2, {opacity:0});
		window.TweenMax.to(this.refs.tuneIn, .3, {opacity:0});
		window.TweenMax.to(this.refs.bg, 1, {opacity:0, onComplete:function(){
			_this.props.handleIntroOutComplete();
		}});

		window.TweenMax.to(this.refs.logo, .4, {opacity:0});
		window.TweenMax.to(this.refs.logo, .5, {ease:"expo.in", transform:"translateX(-150%)"});

		window.TweenMax.to(this.refs.tagline, .4, {opacity:0});
		window.TweenMax.to(this.refs.tagline, .5, {ease:"expo.in", transform:"translateX(50%)"});
		*/
	}


	renderQuestions(){
		return(
			<div className="questions">
				{this.state.categoryData.questions.map(item => {
					let questionID = item.id;
					let questionMod = item.question.replace("[Insert First Name]", this.props.displayName).replace("<BLANK>", "_______");

					return(
						<div className="question" key={questionMod} onClick={() => this.props.handleQuestionsClicked(questionID, questionMod)}>{questionMod}</div>
					)
				})}
			</div>
		)
	}

	render() {

		//console.log("Step2 data", this.state.categoryData);

		return (
			<div id="step2">
				<div className="heading">Step 2: Choose Your Fill-In-The-Blank</div>
				{this.renderQuestions()}
			</div>
		);
	}
}

export default Step2;


// WEBPACK FOOTER //
// ./src/js/components/generator/Step2.js